const PATHS = {
  plus: <path d="M12 5v14M5 12h14" />,
  search: (
    <>
      <circle cx="11" cy="11" r="7" />
      <path d="M20 20l-3.5-3.5" />
    </>
  ),
  up: <path d="M6 14l6-6 6 6" />,
  down: <path d="M6 10l6 6 6-6" />,
  trash: (
    <>
      <path d="M4 7h16" />
      <path d="M9 7V5h6v2" />
      <path d="M7 7l1 13h8l1-13" />
    </>
  ),
  back: <path d="M15 6l-6 6 6 6" />,
  list: (
    <>
      <path d="M8 6h12" />
      <path d="M8 12h12" />
      <path d="M8 18h12" />
      <path d="M4 6h.01" />
      <path d="M4 12h.01" />
      <path d="M4 18h.01" />
    </>
  ),
};

export const Icon = ({ name, size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    {PATHS[name]}
  </svg>
);

export const PageHeader = ({ kicker, title, subtitle, children }) => (
  <header className="at-top">
    <div className="at-heading">
      <p className="at-kicker">{kicker}</p>
      <h1>{title}</h1>
      {subtitle ? <p className="at-sub">{subtitle}</p> : null}
    </div>
    {children ? <div className="at-tools">{children}</div> : null}
  </header>
);

export const stripHtml = (value) =>
  value ? String(value).replace(/<(.|\n)*?>/g, " ").replace(/\s+/g, " ").trim() : "";

export const typeLabel = (type) => {
  if (type === "select") return "Dropdown";
  if (type === "radio") return "Radio";
  if (type === "textarea") return "Free text";
  return type || "Question";
};
